export default __webpack_public_path__ + "static/media/rocket.0792f634.gif";